import { useMemo } from 'react';
import { getClipBroadcastId } from '@goldcast/player-config/src/utils/clipUtils';
import {
  selectSpeakerAnalysis,
  selectSpeakerDetails,
  selectVideoFeeds
} from '@goldcast/player-config/src/selectors/contentMetadataStoreSelectors';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { useContentMetadataStore } from '@/stores/contentMetaDataStore/contentMetaDataStore';
import { buildTimelineSpeakersData } from '@/Pages/Clip/ClipPlayer/ClipNewTimeline/utils';

export const useTimelineSpeakers = () => {
  const { clipData } = useClipsContext();
  const broadcastId = getClipBroadcastId(clipData)!;
  const videoFeeds = useContentMetadataStore(selectVideoFeeds(broadcastId));
  const speakerDetails = useContentMetadataStore(selectSpeakerDetails(broadcastId));
  const speakersAnalysis = useContentMetadataStore(selectSpeakerAnalysis(broadcastId));

  const { speakers, screenShareSpeakerDetails, sharedVideoTrackDetails, screenshareExists } = useMemo(() => {
    return buildTimelineSpeakersData({
      speakerDetails,
      videoFeeds,
      clip: clipData,
      speakerAnalysis: speakersAnalysis
    });
  }, [speakerDetails, videoFeeds, clipData, speakersAnalysis]);

  return {
    speakers,
    videoFeeds,
    recordings: videoFeeds,
    screenshareExists,
    screenShareSpeakerDetails,
    sharedVideoTrackDetails
  };
};
